import React from 'react';
import { Input } from 'reactstrap';
import radioChecked from '../../../assets/images/radio-checked.svg';
import radioUnChecked from '../../../assets/images/radio-unchecked.svg';


const RadioButton = ({radioList, selectedPlanType, onClickRadio}) => {
  return (
    <>
      {
        radioList.map(option => (
          <label key={option.value} className={`assessment-checkbox mb-4 ${option.value === selectedPlanType && 'assessment-checkbox-border'}`} htmlFor={option.value}>
            <span htmlFor={option.value}>{option.label}</span>
            <Input 
              type='radio' 
              className='float-end mt-0 invisible'
              id={option.value}
              value={option.value}
              checked={selectedPlanType === option.value}
              onChange={(e) => onClickRadio(e)}
            />

              <img src={option.value === selectedPlanType ? radioChecked : radioUnChecked} alt=''  />
          </label>
        ))
      }
    </>
  );
}

export default RadioButton;